<template>
<div>
  <el-row type="flex" class="title-bar" justify="space-between">
    <div class="vertical-center-box">
      <div class="title-h3 mr-r4">환경 변수</div>
      <el-button class="mr-l4" size="mini" @click="loadData"><i class="far fa-sync-alt"/></el-button>
    </div>
    <div>
      <el-button size="small" @click="exportEnvInfo"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
      <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </div>
  </el-row>
  <el-table-wrapper :data="tableData" :column-default="columnDefault" v-loading="isLoading" :columns="columns" :pagination="false"
   :show-custom-header="true" :show-search-tool="showSearchTool" :defaultSort="defaultSortCol" style="width:100%;">
  </el-table-wrapper>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil, isEmpty, forIn } from 'lodash';
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty } from '@/utils/string';
import FileApi from '@/api/common/file';
import ApmConfigAPI from '@/api/config/apm/apm-info';

export default {
  name: 'WEnvInfoNode',
  props: {
    activeTab: {
      type: String,
    },
  },
  data() {
    return {
      columnDefault,
      tableData: [],
      defaultSortCol: { prop: 'name', order: 'ascending' },
      showSearchTool: false,
      isLoading: false,
      columns: [
        {
          prop: 'name',
          label: '변수 이름',
          width: 400,
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'envValue',
          label: '변수 값',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      handler() {
        if (!isNil(this.activeTab) && this.activeTab === 'WEnvInfoNode') {
          this.initData();
          this.loadData();
        }
      },
      immediate: true,
    },
    activeTab: {
      handler() {
        if (!isNil(this.activeTab) && this.activeTab === 'WEnvInfoNode') {
          this.initData();
          this.loadData();
        }
      },
    },
  },
  methods: {
    initData() {
      this.showSearchTool = false;
      this.tableData = [];
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    loadData() {
      if (this.isLoading === false) {
        this.isLoading = true;
      }
      ApmConfigAPI.getEnvList({ objId: this.selectedNode.obj.objId }).then((response) => {
        if (response.data.success) {
          const tableList = response.data.data;
          const convertList = [];
          forIn(tableList, (value, key) => {
            convertList.push({
              name: key,
              envValue: value,
            });
          });
          this.tableData = convertList;
        }
        this.isLoading = false;
      });
    },
    exportEnvInfo() {
      if (!isNil(this.selectedNode)) {
        const params = {
          objId: this.selectedNode.obj.objId,
        };
        ApmConfigAPI.getEnvExcelName(params).then((response) => {
          if (response.data.success && !isEmpty(response.data.data)) {
            FileApi.downloadExportedExcelFile(response.data.data);
          }
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/config/node/apm/env/index.vue